export const API_URLS = {
  // SEND_OTP: "5001/v1/users/signup",
  // VERIFY_OTP: "5001/v1/users/verify",
  // UPDATE_USER: "5001/v1/users/update_user",
  // FETCH_VENDORS: "5001/v1/users/filterVendors",
  // FETCH_CITIES: "5001/v1/users/findCities",
  // CREATE_PAYMENT: "5001/v1/users/book_service",
  // GET_ALL_BOOKINGS: "5001/v1/users/get_all_bookings",
  // GET_ALL_ORDERS: "5001/v1/users/viewAllOrders",
  // FETCH_NOTIFICATIONS: "5001/v1/users/view_notifiactions",
  // MARK_AS_READ_NOTIFICATION: "5001/v1/users/markAsRead",

  // CREATE_SERVICE: "5003/v1/create_service",
  // VIEW_SERVICES: "5003/v1/view_service",
  // DELETE_SERVICE: "5003/v1/delete_service",
  // UPDATE_SERVICE: "5003/v1/update_service",
  // FETCH_ALL_VENDORS: "5003/v1/list_all_vendors",
  // TOGGLE_VENDOR_APPROVE_STATUS: "5003/v1/approve_vendor",

  // UPDATE_VENDOR: "5002/v1/vendor/update_vendor",
  // FETCH_VENDOR_BOOKINGS: "5002/v1/vendor/viewall_bookings",
  // VIEW_ALL_EARNINGS: "5002/v1/vendor/view_earnings",
  // TOGGLE_BOOKING_STATUS: "5002/v1/vendor/toggle_status",

  // SOCKET_END_POINT: "http://localhost:5005",

  SEND_OTP: "v1/users/signup",
  VERIFY_OTP: "v1/users/verify",
  UPDATE_USER: "v1/users/update_user",
  FETCH_VENDORS: "v1/users/filterVendors",
  FETCH_CITIES: "v1/users/findCities",
  CREATE_PAYMENT: "v1/users/book_service",
  GET_ALL_BOOKINGS: "v1/users/get_all_bookings",
  GET_ALL_ORDERS: "v1/users/viewAllOrders",
  FETCH_NOTIFICATIONS: "v1/users/view_notifiactions",
  MARK_AS_READ_NOTIFICATION: "v1/users/markAsRead",

  CREATE_SERVICE: "admin/v1/create_service",
  VIEW_SERVICES: "admin/v1/view_service",
  DELETE_SERVICE: "admin/v1/delete_service",
  UPDATE_SERVICE: "admin/v1/update_service",
  FETCH_ALL_VENDORS: "admin/v1/list_all_vendors",
  TOGGLE_VENDOR_APPROVE_STATUS: "admin/v1/approve_vendor",

  UPDATE_VENDOR: "v1/vendor/update_vendor",
  FETCH_VENDOR_BOOKINGS: "v1/vendor/viewall_bookings",
  VIEW_ALL_EARNINGS: "v1/vendor/view_earnings",
  TOGGLE_BOOKING_STATUS: "v1/vendor/toggle_status",

  SOCKET_END_POINT: "http://128.199.18.197",
};

export const config = {
  ENCRYPTION_KEY: "EZZIFY-PESTO",
  ENVIRONMENT: "PROD",
  BASE_URL: "http://128.199.18.197/",
  // BASE_URL: "http://localhost:",
};
